if( ! customElements.get('lp-input-quantity') )
    customElements.define('lp-input-quantity', class extends HTMLElement {
        connectedCallback()
        {
            this.controller = new AbortController()

            this.elements = {}

            this.elements.select   = this.querySelector(':scope select')
            this.elements.increase = this.querySelector(':scope [data-increase]')
            this.elements.decrease = this.querySelector(':scope [data-decrease]')


            this.elements.select?.addEventListener('change', this._emit.bind(this), { signal: this.controller.signal })
            this.elements.increase?.addEventListener('click', this.next.bind(this), { signal: this.controller.signal })
            this.elements.decrease?.addEventListener('click', this.prev.bind(this), { signal: this.controller.signal })

            
            queueMicrotask(() => this._emit())
        }

        disconnectedCallback()
        {
            this.controller?.abort()
            this.controller = null
        }

        next()
        {
            const { increase, decrease, select } = this.elements
            if( ! increase || ! decrease || ! select ) return

            const options_length = select.options.length - 1

            const next_index = select.selectedIndex + 1

            if( next_index >= options_length ) increase.disabled = true
            if( decrease.disabled )            decrease.disabled = false

            select.selectedIndex = next_index

            this._emit()
        }

        prev()
        {
            const { increase, decrease, select } = this.elements
            if( ! increase || ! decrease || ! select ) return

            const prev_index = select.selectedIndex - 1

            if( prev_index < 1 )    decrease.disabled = true
            if( increase.disabled ) increase.disabled = false

            select.selectedIndex = prev_index

            this._emit()
        }

        set( value )
        {
            const { increase, decrease, select } = this.elements
            if( ! increase || ! decrease || ! select ) return

            const options_length = select.options.length - 1

            decrease.disabled = value < 1
            increase.disabled = value >= options_length

            select.selectedIndex = value

            this._emit()
        }

        _emit()
        {
            this.dispatchEvent(new CustomEvent('variant:input:change', { bubbles: true }))

            const { select } = this.elements
            if( ! select ) return

            this.dispatchEvent(new CustomEvent('variant:quantity:change', { 
                bubbles: true,
                detail: select.selectedIndex
            }))
        }
    })

if( ! customElements.get('lp-input-select') )
    customElements.define('lp-input-select', class extends HTMLElement {
        connectedCallback()
        {
            this.controller = new AbortController()

            this.elements       = {}
            this.elements.input = this.querySelector(':scope select')

            this.elements.input?.addEventListener('change', this._emit.bind(this), { signal: this.controller.signal })
        }

        disconnectedCallback()
        {
            this.controller?.abort()
            this.controller = null
        }

        _emit()
        {
            this.dispatchEvent(new CustomEvent('variant:input:change', { bubbles: true }))
        }
    })


if( ! customElements.get('lp-gifts') )
    customElements.define('lp-gifts', class extends HTMLElement {
        connectedCallback()
        {
            this.controller = new AbortController()

            this.elements = {}
            this.elements.steps = this.querySelectorAll(':scope [data-step]')

            this.elements.steps
                ?.forEach( (element, index) => {
                    const trigger = element.querySelector('[data-trigger]')
                    if( ! trigger ) return

                    trigger.addEventListener('click', this._emit.bind(this, index), { signal: this.controller.signal })
                })
        }

        disconnectedCallback()
        {
            this.controller?.abort()
            this.controller = null
        }

        _emit( value )
        {
            this.dispatchEvent( new CustomEvent('variant:gift:select', { 
                bubbles: true,
                detail: value 
            }) )
        }

        set( value )
        {
            const { steps } = this.elements
            if( ! steps.length ) return

            steps.forEach( (step, index) => {
                step.toggleAttribute('data-fullified', index <= value)
                step.toggleAttribute('data-active', index === value)
            })
        }
    })


if( ! customElements.get('lp-prices') )
    customElements.define('lp-prices', class extends HTMLElement {
        connectedCallback()
        {
            this.elements = {}

            this.elements.price             = this.querySelector(':scope [data-price]')
            this.elements.compare_at_price  = this.querySelector(':scope [data-compare-at-price]')
            this.elements.compare_at_price_formated = this.querySelector(':scope [data-compare-at-price] > s')
        }

        set( values )
        {
            const { price, compare_at_price, compare_at_price_formated } = this.elements

            if( price ) {
                this.elements.price.value       = values.price ?? 0
                this.elements.price.textContent = values.formated.price
            }

            if( compare_at_price )         this.elements.compare_at_price.value = values.compare_at_price ?? 0
            if( compare_at_price_formated) this.elements.compare_at_price_formated.textContent = values.formated.compare_at_price
        }
    })


if( ! customElements.get('lp-variant-picker') )
    customElements.define('lp-variant-picker', class extends HTMLElement {
        connectedCallback()
        {
            this.controller = new AbortController()


            this.states = JSON.parse( this.querySelector(':scope [data-states]')?.textContent ?? '[]' )


            this.modules = {}

            this.modules.gifts  = this.querySelector(':scope lp-gifts')
            this.modules.prices = this.querySelector(':scope lp-prices')

            this.modules.input_size     = this.querySelector(':scope lp-input-select')
            this.modules.input_quantity = this.querySelector(':scope lp-input-quantity')


            this.elements = {}

            this.elements.name = this.querySelector(':scope [data-name]')

            this.addEventListener('variant:quantity:change', this._onQuantityChangeHandle.bind(this), { signal: this.controller.signal })
            this.addEventListener('variant:input:change', this._onChangeHandle.bind(this), { signal: this.controller.signal })
            this.addEventListener('variant:gift:select', this._onGiftSelectHandle.bind(this), { signal: this.controller.signal })
        }

        disconnectedCallback()
        {
            this.controller?.abort()
            this.controller = null
        }

        _onGiftSelectHandle({ detail })
        {
            const { input_quantity } = this.modules
            if( ! input_quantity ) return

            input_quantity.set(detail)
        }

        _onQuantityChangeHandle({ detail })
        {
            const { gifts } = this.modules
            if( ! gifts ) return

            gifts.set(detail)
        }

        _onChangeHandle()
        {
            this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true }))
        }

        setCurrentPrice( variant )
        {
            const { prices } = this.modules
            if( ! prices ) return

            prices.set( variant )
        }

        setCurrentVariant( variant )
        {
            const { name } = this.elements
            if( ! name ) return

            name.textContent = variant.options['Quantité']
        }
    })

if( ! customElements.get('lp-buy-button') )
    customElements.define('lp-buy-button', class extends HTMLElement {
        connectedCallback()
        {
            this.elements = {}

            this.elements.form  = this.querySelector(':scope form')
            this.elements.price = this.querySelector(':scope [data-price]')
            this.elements.input = this.querySelector(':scope input[name="id"]')
        }

        setCurrentPrice( variant )
        {
            const { price } = this.elements
            if( ! price ) return

            price.textContent = variant.formated.price
        }

        setCurrentVariant( variant )
        {
            const { input } = this.elements
            if( ! input ) return

            input.value = variant.id
        }

        form()
        {
            const { form } = this.elements
            if( ! form ) return

            return new FormData(form)
        }
    })


if( ! customElements.get('lp-product-form') )
    customElements.define('lp-product-form', class extends HTMLElement {
        connectedCallback()
        {
            this.controller = new AbortController()


            this.states = JSON.parse( this.querySelector(':scope [data-states]')?.textContent ?? '[]')


            this.modules = {}

            this.modules.picker   = this.querySelector(':scope lp-variant-picker')
            this.modules.purchase = this.querySelector(':scope lp-buy-button')


            this.elements = {}

            this.elements.installment = this.querySelector(':scope [data-price-installment]')


            this.addEventListener('variant:change', this._onChangeHandle.bind(this), { signal: this.controller.signal })
        }

        disconnectedCallback()
        {
            this.controller?.abort()
            this.controller = null
        }

        _onChangeHandle()
        {
            const { picker, purchase } = this.modules
            const { installment } = this.elements

            const variant = this._getCurrentVariant()
            if( ! variant ) return

            if( installment ) {
                const installment_value = parseInt(installment.dataset.priceInstallment) ?? 1
                const installment_base  = variant.price

                installment.textContent = this._formatPrice({ cents: installment_base, installment: installment_value  })
            }

            picker?.setCurrentPrice( variant )
            picker?.setCurrentVariant( variant )

            purchase?.setCurrentPrice( variant )
            purchase?.setCurrentVariant( variant )
        }

        _getCurrentVariant()
        {
            const data = this.modules.purchase.form()
            if( ! data ) return

            return this.states.find( variant => 
                Object
                    .entries(variant.options)
                    .every( ([name, value]) => data.get(`options[${ name }]`) === value)
            )
        }

        _formatPrice({ cents, locale = "fr-FR", currency = "EUR", installment = 1} )
        {
            return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency,
            }).format(cents / 100 / installment);
        }
    })


if( ! customElements.get('lp-ui-accordion-item') )
    customElements.define('lp-ui-accordion-item', class extends HTMLElement {
        connectedCallback()
        {
            this.controller = new AbortController()


            this.elements = {}

            this.elements.trigger = this.querySelector(':scope [data-accordion-trigger]')


            this.addEventListener('click', this._onClickHandle.bind(this), { signal: this.controller.signal })
        }

        disconnectedCallback()
        {
            this.controller?.abort()
            this.controller = null
        }

        set open( value ) { this.toggleAttribute('data-accordion-open', value ) }
        get open()        { return this.hasAttribute('data-accordion-open') }

        _onClickHandle()
        {
            this._emit()

            this.open = ! this.open
        }

        _emit()
        {
            this.dispatchEvent(new CustomEvent('accordion:toggle', { bubbles: true }))
        }
    })

if( ! customElements.get('lp-ui-accordion') )
    customElements.define('lp-ui-accordion', class extends HTMLElement {
        connectedCallback()
        {
            this.controller = new AbortController()


            this.modules = {}

            this.modules.items = this.querySelectorAll(':scope lp-ui-accordion-item')


            this.addEventListener('accordion:toggle', this._onToggleHandle.bind(this), { signal: this.controller.signal })
        }

        disconnectedCallback()
        {
            this.controller?.abort()
            this.controller = null
        }

        _onToggleHandle()
        {
            const { items } = this.modules
            if( ! items?.length ) return

            items.forEach(item => item.open = false)
        }
    })

if( ! customElements.get('lp-ui-player') )
    customElements.define('lp-ui-player', class extends HTMLElement {
        connectedCallback()
        {
            this.controller = new AbortController()


            this.elements = {}

            this.elements.controls = this.querySelectorAll(':scope button[data-player-control]')
            this.elements.media    = this.querySelector(':scope [data-player-media] > *')


            this.elements.controls.forEach( control => control.addEventListener('click', this._onClickHandle.bind(this), { signal: this.controller.signal } ))
        }

        disconnectedCallback()
        {
            this.controller?.abort()
            this.controller = null
        }

        set play( value ) { 
            if( ! this.elements.media ) return

            this.toggleAttribute('data-play', value) 

            value 
                ? this.elements.media.play()
                : this.elements.media.pause()
        }

        get play() { return ! this.elements.media?.paused ?? false }


        set muted( value ) { 
            if( ! this.elements.media ) return

            this.elements.media.muted = value
            this.toggleAttribute('data-muted', value) 
        }
        get muted() { return this.elements.media?.muted ?? false }


        _onClickHandle( event )
        {
            const target = event.currentTarget
            if( ! target ) return

            const has_attr_play = target.getAttribute('data-player-control') == 'play'
            const has_attr_audio = target.getAttribute('data-player-control') == 'audio'

            if( has_attr_play ) this.play = ! this.play
            if( has_attr_audio ) this.muted = ! this.muted
        }
    })